

import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FiMenu, FiX, FiUser } from 'react-icons/fi'; // 👤 Added icon
import './Navbar.css';
import logo from '../../assets/logo.jpeg';

const Navbar = () => {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className="navbar">
      {/* Left side → Logo */}
      <div className="navbar-left">
        <Link to="/" className="logo-title" onClick={closeMenu}>
          <img src={logo} alt="Company Logo" className="logo" />
        </Link>
      </div>

      {/* Right side → Menu Icon + Links */}
      <div className="navbar-right">
        <div className="menu-icon" onClick={toggleMenu}>
          {menuOpen ? <FiX size={28} /> : <FiMenu size={28} />}
        </div>

        <ul className={`nav-links ${menuOpen ? 'show' : ''}`}>
          <li><Link to="/" onClick={closeMenu} className={location.pathname === '/' ? 'active' : ''}>Home</Link></li>
          <li><Link to="/about" onClick={closeMenu} className={location.pathname === '/about' ? 'active' : ''}>About</Link></li>
          <li><Link to="/services" onClick={closeMenu} className={location.pathname === '/services' ? 'active' : ''}>Services</Link></li>
          {/* <li><Link to="/products" onClick={closeMenu} className={location.pathname === '/products' ? 'active' : ''}>Products</Link></li> */}
          <li><Link to="/contact" onClick={closeMenu} className={location.pathname === '/contact' ? 'active' : ''}>Contact</Link></li>

          {/* ✅ New Verify Certificate link */}
          <li>
            <Link
              to="/verify-certificate"
              onClick={closeMenu}
              className={location.pathname === '/verify-certificate' ? 'active' : ''}
            >
              Verify Certificate
            </Link>
          </li>

          {/* ✅ Login icon/button */}
          <li className="login-btn">
            <Link to="/login" onClick={closeMenu}>
              <FiUser size={20} className="login-icon" />
              <span className="login-text"></span>
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
